module.exports = __webpack_public_path__ + "img/GBM1_Fibroblasts.a2073594.png";